import { UserProfile } from '@carbon/icons-react'
import { buttonVariants } from 'app/_components/Button'
import { cx } from 'lib/cx'
import Link from 'next/link'
import Avatar, { AvatarSkeleton } from './Avatar'

export type EmployeeDetails = {
  name?: string | null
  email?: string | null
  alias?: string | null
}

export default function EmployeeDetails({
  employee,
  showAvatar = false,
  className,
}: {
  employee?: EmployeeDetails
  showAvatar?: boolean
  className?: string
}) {
  return (
    <div
      className={cx(
        'flex w-fit flex-row items-center gap-2 p-3 pr-1 text-sm',
        className,
      )}
    >
      {showAvatar &&
        (employee?.name || employee?.alias ? (
          <Avatar employee={employee} className="h-9 w-9 border !text-base" />
        ) : (
          <span className="bg-placeholder relative inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border text-xl leading-none font-normal text-white select-none">
            ?
          </span>
        ))}
      {employee ? (
        <>
          <div className="flex flex-1 flex-col gap-1">
            <span className="font-medium">
              {employee.name ? employee.name : employee.email}{' '}
              {employee.alias ? `(${employee.alias})` : null}
            </span>
            <div className="flex flex-1 justify-between gap-4">
              {employee.name || employee.alias ? (
                <a
                  href={`https://teams.microsoft.com/l/chat/0/0?users=${employee.email}`}
                  title="Schreibe eine Nachricht in Microsoft Teams"
                  className="focus text-link-primary hover:underline"
                  target="_blank"
                >
                  Chat
                </a>
              ) : (
                <span className="cursor-not-allowed">Chat</span>
              )}
            </div>
          </div>
          {employee.alias && (
            <Link
              aria-label="Zum Profil"
              href={`https://tbf.digital/user/${employee.alias}`}
              title="Zum Profil"
              className={buttonVariants({
                variant: 'ghost',
                shape: 'icon',
                className: 'text-link-primary p-3 font-medium',
              })}
            >
              <UserProfile className="h-4 w-4" />
            </Link>
          )}
        </>
      ) : (
        <div>User wurde nicht gefunden</div>
      )}
    </div>
  )
}

export function EmployeeDetailsSkeleton({
  showAvatar = false,
  className,
}: {
  showAvatar?: boolean
  className?: string
}) {
  return (
    <div
      className={cx(
        'flex w-full flex-row gap-2 p-3 pr-1 text-sm whitespace-nowrap',
        className,
      )}
    >
      {showAvatar && <AvatarSkeleton />}
      <div className="flex flex-1 flex-col gap-1">
        <div className="flex flex-col gap-2">
          <div className="h-4 w-16 rounded-sm bg-gray-400 py-0 shadow-inner"></div>
          <div className="h-4 w-20 rounded-sm bg-gray-400 py-0 shadow-inner"></div>
        </div>
      </div>
    </div>
  )
}
